// Games against the bot (docs/specs/game-bot). The bot plays with the user id `bot:<level>`.
export type BotLevel = "easy" | "medium" | "hard" | "master";

// Weakest first.
export const BOT_LEVELS: BotLevel[] = ["easy", "medium", "hard", "master"];

// How long the lobby searches for an opponent before it offers the bot.
export const BOT_OFFER_DELAY_MS = 10_000;

const BOT_ID_PREFIX = "bot:";

export function isBotId(userId: string | undefined): boolean {
    return userId?.startsWith(BOT_ID_PREFIX) ?? false;
}

// The level of a bot id, or undefined if it is not one.
export function getBotLevel(userId: string | undefined): BotLevel | undefined {
    if (!userId || !isBotId(userId)) return undefined;
    const level = userId.slice(BOT_ID_PREFIX.length);
    return (BOT_LEVELS as string[]).includes(level) ? level as BotLevel : undefined;
}

export function isBotLevel(value: unknown): value is BotLevel {
    return typeof value === "string" && (BOT_LEVELS as string[]).includes(value);
}

// Translation key of a level's name, e.g. BotLevelMedium.
export function getBotLevelTextKey(level: BotLevel): string {
    return `BotLevel${level.charAt(0).toUpperCase()}${level.slice(1)}`;
}

const LAST_BOT_LEVEL_KEY = "botLevel";

// The level chosen last on this device; Medium at first.
export function getLastBotLevel(storage: { getString(key: string): string | undefined }): BotLevel {
    const saved = storage.getString(LAST_BOT_LEVEL_KEY);
    return isBotLevel(saved) ? saved : "medium";
}

export function setLastBotLevel(storage: { setString(key: string, value: string): void }, level: BotLevel): void {
    storage.setString(LAST_BOT_LEVEL_KEY, level);
}
